export default __webpack_public_path__ + "static/media/img-22-salem.bf2530fa.jpg";